import * as types from './mutation-types';

export const closeTopInfo = function({ commit }: { commit: ( type: string ) => void; }): void {

    commit( types.CLOSETOPINFO );
    commit( types.OPENWILLSHOW );

};

export const topInfoToggle = function (
    { commit, state }: { commit: ( type: string, payload?: any ) => void;state: any; },
    args: { type: string;msgIndex: string;operation: () => void;icon: string;timeout: number;operationIndex: number; }
): void  {

    commit( types.SETTOPINFO, { ...args });

    if ( state.topInfo.timeOut ) {

        clearTimeout( state.topInfo.timeOut );
        state.topInfo.timeOut = null;

    }

    if ( args.timeout ) {

        state.topInfo.timeOut = setTimeout(() => {

            commit( types.CLOSETOPINFO );

        }, args.timeout );

    }

};
